import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Copy, ExternalLink } from 'lucide-react';

export const SettingsLinkTab = ({ company, copyLink, getPreviewUrl }) => (
  <div className="space-y-6">
    <Card className="card-premium">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Link da Sua Pagina</CardTitle>
        <CardDescription>Compartilhe este link com seus clientes</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label className="text-sm font-medium mb-2 block">Link da Sua Pagina</Label>
          <div className="flex items-center gap-2">
            <Input value={getPreviewUrl()} readOnly className="flex-1 h-11 font-mono text-sm" />
            <Button variant="outline" onClick={copyLink} className="h-11"><Copy className="w-4 h-4" /></Button>
            <Link to={`/${company?.slug}`} target="_blank">
              <Button variant="outline" className="h-11"><ExternalLink className="w-4 h-4" /></Button>
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
);
